"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
const math = require("mathjs");
const u = require("../globals/uris");
const maintainer_1 = require("./maintainer");
class Expression {
    constructor(expressionString, isDirected, mathjsTree) {
        this.expressionString = expressionString;
        this.varsAndFuncs = new Map(); //map with vars and funcs
        this.currentMaintainers = new Map();
        this.expressionString = expressionString;
        this.isDirected = isDirected;
        this.mathjsTree = mathjsTree;
        this.generateMathjsTree();
    }
    generateMathjsTree() {
        if (!this.mathjsTree) {
            this.mathjsTree = math.parse(this.expressionString);
        }
        this.isDirected = this.isDirected && this.checkIfFunctionPossible();
        this.treeWithoutFuncs = this.replaceFunctionalExpressions(this.mathjsTree);
    }
    checkIfFunctionPossible() {
        return this.mathjsTree.isOperatorNode && this.mathjsTree["fn"] === "equal"
            && (this.mathjsTree["args"][0].isSymbolNode || this.mathjsTree["args"][0].isFunctionNode);
    }
    getIsDirected() {
        return this.isDirected;
    }
    getFullTree() {
        return this.mathjsTree;
    }
    getVarsAndFuncs() {
        return this.varsAndFuncs;
    }
    evaluate(vars, store) {
        //first gather all functional values
        let varsAndVals = {};
        this.varsAndFuncs.forEach((f, v) => {
            let value = this.getValue(this.getFunctionalObject(f, vars, store), store);
            if (value != null) {
                varsAndVals[v] = value;
            }
        });
        //console.log(this.toString(), varsAndVals, this.treeWithoutFuncs.eval(varsAndVals))
        if (_.keys(vars).length === _.keys(varsAndVals).length) {
            //all values could be found, so eval function with values
            return this.treeWithoutFuncs.eval(varsAndVals);
        }
    }
    maintain(vars, store) {
        if (!this.currentMaintainers.has(vars)) {
            let varsAndUris = new Map();
            let featureFreeTree = this.treeWithoutFuncs;
            //gather the functional objects for all variables and add constants where possible
            this.varsAndFuncs.forEach((f, v) => {
                let objectUriOrVal = this.getFunctionalObject(f, vars, store);
                let objectType = store.findObject(objectUriOrVal, u.TYPE);
                if (objectType === u.FEATURE_TYPE || store.isSubtypeOf(objectType, u.FEATURE_TYPE)) {
                    //replace features (which are immutable) with constants
                    let featureNode = new math.expression.node.ConstantNode(store.findObjectValue(objectUriOrVal, u.VALUE));
                    featureFreeTree = this.replaceSymbolInTree(featureFreeTree, v, featureNode);
                }
                else if (objectUriOrVal != null && typeof objectUriOrVal !== 'string') {
                    //insert numerical and boolean constants TODO also string ones....
                    let featureNode = new math.expression.node.ConstantNode(objectUriOrVal);
                    featureFreeTree = this.replaceSymbolInTree(featureFreeTree, v, featureNode);
                }
                else {
                    varsAndUris.set(v, objectUriOrVal);
                }
            });
            //console.log(vars, varsAndUris)
            this.currentMaintainers.set(vars, new maintainer_1.Maintainer(varsAndUris, featureFreeTree, this.isDirected, store));
        }
    }
    stopMaintaining() {
        this.currentMaintainers.forEach(m => m.stop());
        this.currentMaintainers = new Map();
    }
    replaceSymbolInTree(tree, symbol, newNode) {
        return tree.transform(node => node.isSymbolNode && node.name === symbol ? newNode : node);
    }
    getValue(uri, store) {
        let value = store.findObjectValue(uri, u.VALUE);
        return value != null ? value : uri;
    }
    getFunctionalObject(expression, vars, store) {
        if (expression.isFunctionNode) {
            let arg = this.getFunctionalObject(expression["args"][0], vars, store);
            let name = expression["fn"]["name"];
            let officialName, customName;
            if (name) {
                officialName = name.indexOf(u.DYMO_ONTOLOGY_URI) >= 0 ? name : u.DYMO_ONTOLOGY_URI + name;
                customName = name.indexOf(u.CONTEXT_URI) >= 0 ? name : u.CONTEXT_URI + name;
            }
            //search for a matching predicate
            let result = store.findObject(arg, officialName);
            if (result == null && customName) {
                result = store.findObject(arg, customName);
            }
            //search for a matching control param
            if (result == null && name) {
                result = store.findObjectOfType(arg, u.HAS_CONTROL_PARAM, u.MOBILE_AUDIO_ONTOLOGY_URI + name);
            }
            //search for a matching feature or param
            if (result == null && officialName) {
                result = this.findOrInitFeatureOrParam(arg, officialName, store);
            }
            if (result == null && customName) {
                result = this.findOrInitFeatureOrParam(arg, customName, store);
            }
            return result;
        }
        //it's the innermost symbol node
        return vars[expression.name];
    }
    findOrInitFeatureOrParam(owner, type, store) {
        //try finding existing attribute
        let attributeUri = store.findAttributeUri(owner, type);
        if (attributeUri) {
            return attributeUri;
        }
        //try adding attribute if defined somewhere
        let typeOfType = store.findObject(type, u.TYPE);
        if (typeOfType === u.FEATURE_TYPE || store.isSubclassOf(typeOfType, u.FEATURE_TYPE)) {
            //not very useful, feature will be null forever
            return store.setFeature(owner, type);
        }
        else if (typeOfType === u.PARAMETER_TYPE || store.isSubclassOf(typeOfType, u.PARAMETER_TYPE)) {
            return store.setParameter(owner, type);
        }
    }
    replaceFunctionalExpressions(mathjsTree) {
        let varCount = 0;
        return mathjsTree.transform(node => {
            //replace only non-js functions (predicates or charm attributes)
            //TODO name length is a temporary trick (js func rarely have such short names...)
            if ((node.isFunctionNode && node["fn"].isSymbolNode) || (node.isSymbolNode && node["name"].length == 1)) {
                let currentVarname = "v" + varCount++;
                this.varsAndFuncs.set(currentVarname, node);
                return new math.expression.node.SymbolNode(currentVarname);
            }
            return node;
        });
    }
    toString() {
        return this.mathjsTree.toString();
    }
}
exports.Expression = Expression;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/model/expression.js
// module id = 413
// module chunks = 3